
import { styledBoxOptions, StyledBoxOptions } from '@/support/StyledBox';
import { Component, Prop, Vue } from 'vue-property-decorator';
import RequestTypeFilter from '@/components/request/RequestTypeFilter/RequestTypeFilter';
import { LocaleMessage } from 'vue-i18n';

@Component<BlockType>({
  components: {
    'request-type-filter': RequestTypeFilter,
  }
})
export default class BlockType extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private isEditing!: boolean;

  private get types(): StyledBoxOptions[] {
    return styledBoxOptions;
  }

  private get type(): string | LocaleMessage {
    const result: StyledBoxOptions | undefined = this.types.find((type: StyledBoxOptions): boolean => type.value === this.value);
    return result && result.text ? result.text : '';
  }
}
